<template>
  <v-container fluid>
    <v-row align="center" justify="space-between" class="mb-4">
      <v-col cols="12" md="8">
        <h2 class="text-h5 font-weight-bold">Nueva orden de producción</h2>
      </v-col>
      <v-col cols="12" md="4" class="text-md-right">
        <v-btn text color="primary" @click="$router.back()">
          <v-icon left>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <!-- Configuración -->
      <v-col cols="12" md="5">
        <v-card class="mb-4">
          <v-card-title class="subtitle-1 font-weight-bold">Configuración</v-card-title>
          <v-card-text>
            <v-autocomplete
              v-model="recetaSeleccionada"
              :items="recetas"
              :loading="loadingRecetas"
              item-text="nombre"
              item-value="id"
              outlined
              dense
              label="Receta / Programa"
              placeholder="Elegí qué producir"
              return-object
              clearable
            />
            <v-text-field
              v-model.number="cantidadLotes"
              type="number"
              min="1"
              label="Cantidad de lotes (corridas / placas)"
              outlined
              dense
            />
            <v-select
              v-model="maquinaSeleccionada"
              :items="maquinas"
              item-text="nombre"
              item-value="id"
              outlined
              dense
              label="Máquina"
              clearable
              hint="Si no elegís, se usa la de la receta"
              persistent-hint
            />
          </v-card-text>
          <v-card-actions class="px-4 pb-4">
            <v-btn
              block
              color="deep-purple"
              dark
              :disabled="!recetaSeleccionada || cantidadLotes < 1"
              :loading="guardando"
              @click="crear"
            >
              <v-icon left>mdi-content-save</v-icon>
              Crear orden
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- Preview de la receta -->
      <v-col cols="12" md="7">
        <v-card v-if="recetaSeleccionada">
          <v-card-title class="subtitle-1 font-weight-bold">
            Vista previa
            <v-spacer />
            <span class="caption grey--text">x {{ cantidadLotes || 1 }} lote(s)</span>
          </v-card-title>
          <v-card-text>
            <p class="overline mb-1 red--text text--darken-1">Consume</p>
            <v-simple-table dense>
              <tbody>
                <tr v-for="c in recetaSeleccionada.consumos" :key="'c' + c.id">
                  <td>{{ c.descripcion }}</td>
                  <td class="text-right">{{ porLote(c.cantidad) }}</td>
                </tr>
              </tbody>
            </v-simple-table>

            <p class="overline mb-1 mt-4 green--text text--darken-1">Produce</p>
            <v-simple-table dense>
              <tbody>
                <tr v-for="s in recetaSeleccionada.salidas" :key="'s' + s.id">
                  <td>{{ s.descripcion }}</td>
                  <td class="text-right">{{ porLote(s.cantidad) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <v-card v-else outlined class="d-flex align-center justify-center" style="min-height: 200px">
          <span class="grey--text">Elegí una receta para ver qué consume y produce</span>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'OrdenProduccionRegistrar',
  data() {
    return {
      recetas: [],
      maquinas: [],
      loadingRecetas: false,
      recetaSeleccionada: null,
      cantidadLotes: 1,
      maquinaSeleccionada: null,
      guardando: false,
    };
  },
  watch: {
    recetaSeleccionada(val) {
      if (val && val.maquina) this.maquinaSeleccionada = val.maquina;
    },
  },
  methods: {
    ...mapActions('recetaProduccion', ['fetch_recetas']),
    ...mapActions('maquinaProduccion', ['fetch_maquinas']),
    ...mapActions('ordenProduccion', ['create_orden']),

    porLote(cant) {
      const n = (parseFloat(cant) || 0) * (this.cantidadLotes || 1);
      return Number(n).toLocaleString('es-AR');
    },

    snack(color, text, icon) {
      this.$updateBus.$emit('showSnackBar', { show: true, button: false, color, text, icon, timeout: 3000 });
    },

    async fetchData() {
      this.loadingRecetas = true;
      try {
        const [r, m] = await Promise.all([this.fetch_recetas(), this.fetch_maquinas()]);
        this.recetas = r.data.filter(x => x.activa !== false);
        this.maquinas = m.data;
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingRecetas = false;
      }
    },

    async crear() {
      this.guardando = true;
      try {
        const payload = {
          receta: this.recetaSeleccionada.id,
          cantidad_lotes: this.cantidadLotes,
          maquina: this.maquinaSeleccionada || null,
        };
        const res = await this.create_orden(payload);
        this.snack('success', 'Orden creada', 'mdi-check');
        this.$router.push({ name: 'empresa.produccion.orden.consultar', params: { id: res.data.id } });
      } catch (e) {
        const msg = e.response?.data?.error || 'Error al crear la orden';
        this.snack('error', msg, 'mdi-alert');
      } finally {
        this.guardando = false;
      }
    },
  },
  created() {
    this.fetchData();
  },
};
</script>
